import { useEffect, useState, useCallback } from "react";
import { deleteZoning, addZoning, updateZoning, getAllZoning, reactivateZoning } from '../ZoningService'

export default function useZoning() {
    const [shouldOpenEditorDialog, setShouldOpenEditorDialog] = useState(false);
    const [zoning, setZoning] = useState(null);
    const [shouldOpenConfirmationDialog, setShouldOpenConfirmationDialog] = useState(false);
    const [shouldOpenReactivateConfirmationDialog, setShouldOpenReactivateConfirmationDialog] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (_, newPage) => setPage(newPage);
    const [zonings, setZonings] = useState([]);

    useEffect(() => {
        updatePageData();
    }, []);

    const handleEditUser = (zoning) => async (event) => {
        setZoning(zoning);
        setShouldOpenEditorDialog(true);
    };

    const updatePageData = () => {
        getAllZoning().then(response => {
            setZonings(response.data.zonings);
        }).catch(error => {
            console.error('Failed to fetch Zone data', error);
        });
    };

    const handleSave = async (zoning, isNew, setFieldError) => {
        let apiPayload;
        if (isNew) {
            apiPayload = {
                Code: zoning.Code,
                Description: zoning.Description
            };
            const response = await addZoning(apiPayload);
            if (response.data.success) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000);
                handleDialogClose();
                setTimeout(updatePageData, 500);
            } else {
                setFieldError('Code', response.data.errorMessage);
                return response.data.errorMessage;
            }
        } else {
            apiPayload = {
                Id: zoning.ID,
                Code: zoning.Code,
                Description: zoning.Description,
                StatusLUId: zoning.StatusLUId
            };

            const response = await updateZoning(apiPayload);
            if (response.data.success) {
                handleDialogClose();
                setTimeout(updatePageData, 500);
            } else {
                setFieldError('Code', response.data.errorMessage);
                return response.data.errorMessage;
            }
        }
    };

    const handleDialogClose = () => {
        setShouldOpenEditorDialog(false);
        setShouldOpenConfirmationDialog(false);
        setShouldOpenReactivateConfirmationDialog(false);
        updatePageData();
    };

    const handleConfirmationResponse = () => {
        if (zoning) {
            deleteZoning(zoning.id).then(response => {
                if (response.data.success) {
                    setShowSuccessAlert(true);
                    setTimeout(() => setShowSuccessAlert(false), 3000);
                    handleDialogClose();
                    setTimeout(updatePageData, 500);
                } else {
                    alert('Failed to delete Zone.');
                }
            }).catch(error => {
                console.error('Error deleting Zone', error);
                alert('Failed to delete Zone.');
            });
        }
    };

    const handleDeleteUser = (user) => {
        setZoning(user);
        setShouldOpenConfirmationDialog(true);
    };

    const handleReactivateZoning = (zoningRecord) => {
        setZoning(zoningRecord);
        setShouldOpenReactivateConfirmationDialog(true);
    };

    const handleReactivateConfirmationResponse = async () => {
        if (zoning) {
            reactivateZoning(zoning.id).then(response => {
                if (response.data.success) {
                    handleDialogClose();
                    setTimeout(updatePageData, 500);
                } else {
                    alert('Failed to reactivate Zone.');
                }
            }).catch(error => {
                console.error('Error reactivating Zone', error);
                alert('Failed to reactivate Zone.');
            });
        }
    };

    return {
        setZoning,
        setShouldOpenEditorDialog,
        handleEditUser,
        handleDeleteUser,
        shouldOpenEditorDialog,
        page,
        rowsPerPage,
        setRowsPerPage,
        zoning,
        handleDialogClose,
        handleSave,
        zonings,
        shouldOpenConfirmationDialog,
        handleConfirmationResponse,
        handleChangePage,
        updatePageData,
        handleReactivateZoning,
        handleReactivateConfirmationResponse,
        shouldOpenReactivateConfirmationDialog,
        setShouldOpenReactivateConfirmationDialog
    }
}   